import { withInstall } from '@vuesax-alpha/utils'
import TimeSelect from './src/time-select.vue'

export const VsTimeSelect = withInstall(TimeSelect)

export default VsTimeSelect

export * from './src/time-select'
